module.exports = __webpack_public_path__ + "media/wyposazenie/kola@2x-13d22107.png";